import { z } from 'zod';

export const loginSchema = z.object({
  login: z.string().min(1, { message: '请输入用户名/邮箱/手机号' }),
  password: z.string().min(1, { message: '请输入密码' }),
  captchaKey: z.string().min(1, { message: '验证码key不能为空' }),
  captchaCode: z.string().min(1, { message: '请输入验证码' }),
  from: z.string().optional(),
});

export type LoginSchemaType = typeof loginSchema;
export type LoginFormData = z.infer<LoginSchemaType>;
